export class DesktopSelectMenu {
    constructor(optionalOptions = {}) {
        this._buttons = document.querySelectorAll('.menu-list--wrap .menu-list-item--add');

        if (!this._buttons) {
            this.destructor();
            return true;
        }

        this._buttons.forEach((one) => {
            one.addEventListener("click", (event) => {
                event.preventDefault();
                window.showModal('modal-desktop-menu-add-order');
            })
        })
    }

    destructor() {
        this._buttons = null;
    }
}

export default new DesktopSelectMenu();
